import React from "react";

const Solution = () => {
	// Internal component for info boxes
	const InfoBox = ({ imageSrc, imageAlt, title, description }) => (
		<div className="bg-inherit p-6 rounded-3xl h-[400px] border border-gray-200 hover:scale-105 transition-all duration-300">
			<div className="flex flex-col h-full">
				{/* Image at top - larger and more prominent */}
				<div className="max-h-[120px] flex items-center justify-center mb-4 overflow-hidden">
					<img
						src={imageSrc}
						alt={imageAlt}
						className="w-full h-full mt-0 rounded-t-xl object-cover"
					/>
				</div>
				{/* Title below image */}
				<div className="mb-3 text-left">
					<h3 className="text-swift-pink text-xl font-normal font-generalSans">
						{title}
					</h3>
				</div>
				{/* Description text */}
				<div className="flex-1">
					<p className="text-swift-dark text-base font-light leading-relaxed font-generalSans">
						{description}
					</p>
				</div>
			</div>
		</div>
	);

	return (
		<section className="bg-inherit pt-20">
			<div className="max-w-7xl mx-auto px-4">
				{/* Cards Container - Horizontal on big screens, vertical on small screens */}
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-6">
					{/* First Box - Our Solution */}
					<div className="bg-swift-pink p-6 rounded-3xl h-[400px] hover:scale-105 transition-all duration-300">
						<div className="flex flex-col h-full">
							<div className="flex items-center gap-4 mb-4">
								<p className="text-2xl lg:text-3xl xl:text-4xl font-normal text-white font-generalSans">
									Our solution
								</p>
							</div>
							<div className="flex-1 flex items-end">
								<p className="text-white text-sm font-light leading-relaxed font-generalSans">
									We primarily partner with three key sectors:
									schools, government, and businesses to
									advance menstrual health solutions across
									Africa.
								</p>
							</div>
						</div>
					</div>

					{/* Second Box - Students/Education */}
					<InfoBox
						imageSrc="/assets/images/Schools-2.jpg"
						imageAlt="Students in classroom"
						title="Schools"
						description="We empower students to stay healthy and informed by directly addressing menstrual health challenges through on-campus education programs."
					/>

					{/* Third Box - Business/CSR */}
					<InfoBox
						imageSrc="/assets/images/Business.jpg"
						imageAlt="Business meeting"
						title="Businesses"
						description="We offer strategic sponsorship opportunities for businesses to demonstrate their CSR commitment and community empowerment with detailed impact reports."
					/>

					{/* Fourth Box - Government Cooperation */}
					<InfoBox
						imageSrc="/assets/images/Ministry-of-Education.webp"
						imageAlt="Government building"
						title="Government"
						description="We partner with Ministries and Government agencies to integrate menstrual health solutions into national education and public health strategies."
					/>
				</div>
			</div>
		</section>
	);
};

export default Solution;
